/**
 * Category-specific fields: Jobs, Furniture, Fashion, Pets, Books, Services, Kids, Tools, Music, Legacy.
 */
const currentYear = new Date().getFullYear();

export const generalFields = {
  Jobs: [
    {
      key: 'jobType',
      label: 'Job type *',
      type: 'select',
      options: [
        'Full-time',
        'Part-time',
        'Contract',
        'Internship',
        'Temporary',
        'Work from home',
      ],
      required: true,
    },
    {
      key: 'salaryPeriod',
      label: 'Salary period *',
      type: 'select',
      options: ['Monthly', 'Yearly', 'Hourly', 'Weekly', 'Lump sum'],
      required: true,
    },
    {
      key: 'salaryMin',
      label: 'Salary from (€)',
      type: 'number',
      min: 0,
      placeholder: 'Minimum salary',
    },
    {
      key: 'salaryMax',
      label: 'Salary to (€)',
      type: 'number',
      min: 0,
      placeholder: 'Maximum salary',
    },
    {
      key: 'company',
      label: 'Company name',
      type: 'text',
      placeholder: 'Company or business name',
    },
    {
      key: 'experience',
      label: 'Experience required',
      type: 'select',
      options: [
        'Fresher',
        '0-1 years',
        '1-3 years',
        '3-5 years',
        '5-10 years',
        '10+ years',
      ],
    },
    {
      key: 'qualification',
      label: 'Qualification',
      type: 'select',
      options: [
        '10th or Below 10th',
        '12th Pass',
        'Diploma',
        'ITI',
        'Graduate',
        'Post Graduate',
        'PhD',
        'Other',
      ],
    },
    {
      key: 'positionType',
      label: 'Position type',
      type: 'select',
      options: ['Office based', 'Field job', 'Work from home', 'Hybrid'],
    },
    {
      key: 'openings',
      label: 'Number of openings',
      type: 'number',
      min: 1,
      placeholder: 'e.g. 1, 5, 10',
    },
  ],
  Furniture: [
    {
      key: 'furnitureType',
      label: 'Furniture type *',
      type: 'select',
      options: [
        'Sofa & Dining',
        'Beds & Wardrobes',
        'Tables & Desks',
        'Chairs',
        'TV Units & Cabinets',
        'Bookshelves',
        'Home Decor & Garden',
        'Kids Furniture',
        'Office Furniture',
        'Other',
      ],
      required: true,
    },
    {
      key: 'material',
      label: 'Material',
      type: 'select',
      options: [
        'Wood',
        'Metal',
        'Plastic',
        'Glass',
        'Fabric',
        'Leather',
        'Rattan / Cane',
        'Engineered Wood',
        'Other',
      ],
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'e.g. IKEA, Godrej, Urban Ladder',
    },
    {
      key: 'purchaseYear',
      label: 'Year of purchase',
      type: 'number',
      min: 2000,
      max: currentYear,
    },
    {
      key: 'dimensions',
      label: 'Dimensions',
      type: 'text',
      placeholder: 'e.g. 6x5 ft, L-shaped',
    },
    {
      key: 'deliveryAvailable',
      label: 'Delivery available',
      type: 'select',
      options: ['Yes', 'No', 'Can negotiate'],
    },
  ],
  Fashion: [
    {
      key: 'fashionType',
      label: 'Type *',
      type: 'select',
      options: [
        'Clothing',
        'Footwear',
        'Watches',
        'Jewellery',
        'Bags & Wallets',
        'Sunglasses',
        'Accessories',
        'Other',
      ],
      required: true,
    },
    {
      key: 'forGender',
      label: 'For',
      type: 'select',
      options: ['Men', 'Women', 'Unisex', 'Kids'],
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'e.g. Zara, Nike, H&M',
    },
    {
      key: 'size',
      label: 'Size',
      type: 'select',
      options: [
        'XS',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'Free Size',
        'Custom',
        'N/A',
      ],
    },
    {
      key: 'color',
      label: 'Color',
      type: 'text',
      placeholder: 'e.g. Blue, Multi-color',
    },
    {
      key: 'material',
      label: 'Material',
      type: 'text',
      placeholder: 'e.g. Cotton, Silk, Leather',
    },
  ],
  Pets: [
    {
      key: 'petType',
      label: 'Pet type *',
      type: 'select',
      options: [
        'Dog',
        'Cat',
        'Bird',
        'Fish',
        'Rabbit',
        'Hamster',
        'Turtle / Tortoise',
        'Other',
      ],
      required: true,
    },
    {
      key: 'breed',
      label: 'Breed',
      type: 'text',
      placeholder: 'e.g. Labrador, Persian, Budgie',
    },
    {
      key: 'age',
      label: 'Age',
      type: 'text',
      placeholder: 'e.g. 2 months, 1 year',
    },
    {
      key: 'gender',
      label: 'Gender',
      type: 'select',
      options: ['Male', 'Female', 'Pair', 'Not sure'],
    },
    {
      key: 'vaccinated',
      label: 'Vaccinated',
      type: 'select',
      options: ['Yes', 'No', 'Partially'],
    },
    {
      key: 'healthCertificate',
      label: 'Health certificate',
      type: 'select',
      options: ['Yes', 'No'],
    },
    {
      key: 'kciRegistered',
      label: 'KCI registered',
      type: 'select',
      options: ['Yes', 'No', 'N/A'],
    },
  ],
  'Books, Sports & Hobbies': [
    {
      key: 'type',
      label: 'Type *',
      type: 'select',
      options: [
        'Books',
        'Gym & Fitness',
        'Musical Instruments',
        'Sports Equipment',
        'Art & Collectibles',
        'Other Hobbies',
      ],
      required: true,
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'Brand or author name',
    },
    {
      key: 'language',
      label: 'Language',
      type: 'text',
      placeholder: 'e.g. English, French',
    },
    {
      key: 'edition',
      label: 'Edition / Year',
      type: 'text',
      placeholder: 'e.g. 2nd Edition, 2023',
    },
  ],
  Services: [
    {
      key: 'serviceType',
      label: 'Service type *',
      type: 'select',
      options: [
        'Education & Classes',
        'Tours & Travel',
        'Electronics Repair',
        'Health & Beauty',
        'Home Renovation',
        'Cleaning & Pest Control',
        'Legal & Documentation',
        'Movers & Packers',
        'Photography & Video',
        'Event Planning',
        'Other Services',
      ],
      required: true,
    },
    {
      key: 'experience',
      label: 'Years of experience',
      type: 'text',
      placeholder: 'e.g. 5 years',
    },
    {
      key: 'serviceArea',
      label: 'Service area',
      type: 'text',
      placeholder: 'e.g. Within city, Pan EU',
    },
    {
      key: 'availability',
      label: 'Availability',
      type: 'select',
      options: ['Weekdays', 'Weekends', 'All days', 'On call'],
    },
    {
      key: 'priceType',
      label: 'Price type',
      type: 'select',
      options: [
        'Fixed',
        'Per hour',
        'Per session',
        'Negotiable',
        'Free consultation',
      ],
    },
  ],
  Kids: [
    {
      key: 'type',
      label: 'Type *',
      type: 'select',
      options: [
        'Toys & Games',
        'Baby Clothing',
        'Strollers & Carriers',
        'School Supplies',
        'Baby Gear',
        'Feeding & Nursing',
        'Diapers & Wipes',
        'Kids Accessories',
        'Other',
      ],
      required: true,
    },
    {
      key: 'ageGroup',
      label: 'Suitable age group',
      type: 'select',
      options: [
        '0-6 months',
        '6-12 months',
        '1-2 years',
        '2-4 years',
        '4-6 years',
        '6-10 years',
        '10+ years',
        'All ages',
      ],
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'e.g. Fisher Price, Lego',
    },
    {
      key: 'forGender',
      label: 'For',
      type: 'select',
      options: ['Boys', 'Girls', 'Unisex'],
    },
    {
      key: 'safetyStandard',
      label: 'Safety certified',
      type: 'select',
      options: ['Yes', 'No', 'Not sure'],
    },
  ],
  'Tools & Machinery': [
    {
      key: 'type',
      label: 'Type *',
      type: 'select',
      options: [
        'Power Tools',
        'Hand Tools',
        'Industrial Machinery',
        'Garden Equipment',
        'Welding Equipment',
        'Generators',
        'Compressors',
        'Other',
      ],
      required: true,
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'e.g. Bosch, Makita, Stanley',
    },
    {
      key: 'powerSource',
      label: 'Power source',
      type: 'select',
      options: [
        'Electric (Corded)',
        'Battery / Cordless',
        'Petrol / Diesel',
        'Manual',
        'Pneumatic',
      ],
    },
    {
      key: 'warranty',
      label: 'Warranty',
      type: 'select',
      options: ['Under warranty', 'Expired', 'No warranty'],
    },
    {
      key: 'purchaseYear',
      label: 'Year of purchase',
      type: 'number',
      min: 2000,
      max: currentYear,
    },
  ],
  'Music & Instruments': [
    {
      key: 'instrumentType',
      label: 'Instrument type *',
      type: 'select',
      options: [
        'Guitar (Acoustic)',
        'Guitar (Electric)',
        'Guitar (Bass)',
        'Keyboard / Piano',
        'Drums & Percussion',
        'Violin / Viola',
        'Flute',
        'Harmonium',
        'Tabla',
        'Sitar',
        'Ukulele',
        'DJ Equipment',
        'Studio Equipment',
        'Amplifier',
        'Other',
      ],
      required: true,
    },
    {
      key: 'brand',
      label: 'Brand',
      type: 'text',
      placeholder: 'e.g. Yamaha, Fender, Roland',
    },
    { key: 'model', label: 'Model', type: 'text', placeholder: 'Model name' },
    {
      key: 'purchaseYear',
      label: 'Year of purchase',
      type: 'number',
      min: 1990,
      max: currentYear,
    },
    {
      key: 'accessoriesIncluded',
      label: 'Accessories included',
      type: 'text',
      placeholder: 'e.g. Case, Strings, Stand',
    },
  ],
  Vehicles: [
    { key: 'brand', label: 'Brand', type: 'text', placeholder: 'Brand' },
    { key: 'model', label: 'Model', type: 'text', placeholder: 'Model' },
    {
      key: 'year',
      label: 'Year',
      type: 'number',
      min: 1990,
      max: currentYear + 1,
    },
    { key: 'kmDriven', label: 'KM driven', type: 'number', min: 0 },
    {
      key: 'fuelType',
      label: 'Fuel type',
      type: 'select',
      options: ['Petrol', 'Diesel', 'CNG', 'Electric'],
    },
    {
      key: 'owners',
      label: 'No. of owners',
      type: 'select',
      options: ['1st', '2nd', '3rd', '4+'],
    },
    { key: 'color', label: 'Color', type: 'text', placeholder: 'Color' },
  ],
  Property: [
    {
      key: 'listingType',
      label: 'Listing type',
      type: 'select',
      options: ['For Sale', 'For Rent'],
    },
    {
      key: 'propertyType',
      label: 'Property type',
      type: 'select',
      options: [
        'Apartments',
        'Houses & Villas',
        'Lands & Plots',
        'Shops & Offices',
      ],
    },
    {
      key: 'bedrooms',
      label: 'Bedrooms',
      type: 'select',
      options: ['1', '2', '3', '4', '4+'],
    },
    {
      key: 'bathrooms',
      label: 'Bathrooms',
      type: 'select',
      options: ['1', '2', '3', '4', '4+'],
    },
    {
      key: 'furnishing',
      label: 'Furnishing',
      type: 'select',
      options: ['Furnished', 'Semi-Furnished', 'Unfurnished'],
    },
    {
      key: 'superBuiltupArea',
      label: 'Super built-up area (sq ft)',
      type: 'number',
      min: 0,
    },
    { key: 'carpetArea', label: 'Carpet area (sq ft)', type: 'number', min: 0 },
    {
      key: 'listedBy',
      label: 'Listed by',
      type: 'select',
      options: ['Owner', 'Builder', 'Dealer'],
    },
  ],
  Electronics: [
    { key: 'brand', label: 'Brand', type: 'text', placeholder: 'Brand' },
    { key: 'model', label: 'Model', type: 'text', placeholder: 'Model' },
    {
      key: 'warranty',
      label: 'Warranty',
      type: 'select',
      options: ['Under warranty', 'Out of warranty'],
    },
    {
      key: 'purchaseYear',
      label: 'Year of purchase',
      type: 'number',
      min: 2000,
      max: currentYear,
    },
  ],
  'Mobile Phones': [
    { key: 'brand', label: 'Brand', type: 'text', placeholder: 'Brand' },
    { key: 'model', label: 'Model', type: 'text', placeholder: 'Model' },
    {
      key: 'ram',
      label: 'RAM (GB)',
      type: 'select',
      options: ['2', '3', '4', '6', '8', '12', '16'],
    },
    {
      key: 'storage',
      label: 'Storage (GB)',
      type: 'select',
      options: ['16', '32', '64', '128', '256', '512'],
    },
    {
      key: 'chargerIncluded',
      label: 'Charger included',
      type: 'select',
      options: ['Yes', 'No'],
    },
    {
      key: 'billAvailable',
      label: 'Bill available',
      type: 'select',
      options: ['Yes', 'No'],
    },
  ],
};
